export default "__VITE_ASSET__7d1cea8b__"